import { Component, Input, OnInit } from '@angular/core';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatProgressBar } from '@angular/material/progress-bar';

export type IndicatorTheme = 'default' | 'material';
export type IndicatorType = 'bar' | 'circle';

export interface LoadingConfig {
    theme: IndicatorTheme;
    type: IndicatorType;
}

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    imports: [MatProgressSpinner, MatProgressBar]
})
export class LoadingIndicatorComponent {
    @Input() theme: IndicatorTheme = 'default';
    @Input() type: IndicatorType = 'circle';

    constructor() { }

    get indicatorType() {
        return this.type;
    }

}
